<template>
  <div>
    <tabs :tabs="statuses">
      <panel title="Wnioski">
        <w-table
          entity-type="document"
          id-key="documentId"
          :columns="columns"
          :data="list"
          :actions="actions"
          :total="count"
          :hide-add-button="true"
          :per-page="-1"
          @setStatus="openStatusPicker"
          @view="goToDetails"
        />
      </panel>
    </tabs>

    <pick-status-modal
      :id="statusPickerDocumentId"
      :object="statusPickerDocument"
      :show="showStatusPicker"
      @update="saveStatus"
      @close="closeStatusPicker"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import WTable from '@/components/table/Table';
import Tabs from '@/components/tabs/Tabs';
import { Errors } from '@/enums/errors.enum';
import { boolean } from '@/filters/boolean';
import { documentManageMixin } from '@/mixins/document/documentManage';
import { listMixin } from '@/mixins/list';
import { SET_STATUS_ACTION, VIEW_ACTION } from '@/utils/constants';
import { documentIndexFilters } from '@/utils/document';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania wniosków.',
  getError: 'Wystąpił błąd podczas pobierania danych wniosku.',
  added: 'Dodano wniosek.',
  addError: 'Nie udało się dodać wniosku.',
  updated: 'Zaktualizowano dane wniosku.',
  updateError: 'Nie udało się zaktualizować danych wniosku.',
  deleteConfirm: 'Czy na pewno chcesz usunąć wniosek?',
  deleted: 'Usunięto wniosek.',
  deleteError: 'Nie udało się usunąć wniosku.'
};

// @vuese
// Lista dokumentów
// @group document
export default {
  components: { Tabs, WTable },
  mixins: [listMixin('document', messages), documentManageMixin],
  data() {
    return {
      actions: [{ ...VIEW_ACTION, permissionTypes: [] }, SET_STATUS_ACTION],

      columns: [
        { name: 'documentId', displayName: 'ID', sortable: true },
        { name: 'data.title', displayName: 'Tytuł', action: 'view', sortable: true },
        { name: 'procedure.name', displayName: 'Procedura', sortable: true },
        {
          name: 'data.warnings',
          displayName: 'Ostrzeżenia',
          nameTransformer: warnings => boolean(warnings && warnings.length),
          sortable: true
        }
      ]
    };
  },
  computed: mapState({
    statuses(state) {
      const name = this.$route.name;
      const statuses = state.status.list.map(status => ({
        title: status.name,
        route: { name, query: { statusId: status.id } }
      }));
      statuses.unshift({ title: 'Wszystkie', route: { name, query: { statusId: undefined } } });
      return statuses;
    },

    list: state => state.documentIndex.list,
    count: state => state.documentIndex.count
  }),
  methods: {
    // @vuese
    // Przenosi do szczegółów wniosku
    goToDetails(document) {
      this.$router.push({
        name: 'documentDetails',
        params: { documentId: document.documentId, procedureId: document.procedureId },
        query: this.$route.query
      });
    },

    // @vuese
    // Aktualizacja listy
    updateList(to, from, next) {
      this.$store
        .dispatch('documentIndex/listNoColors', documentIndexFilters(to, { withProfileId: true, disallowHidden: true }))
        .then(() => next())
        .catch(err => this.notifyError(Errors.DOCUMENT_CANNOT_LIST));
    }
  }
};
</script>
